import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TabIcon(props: IconProps) {
    return <Icon {...props} iconKey={"tab"}/>
}
